<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<h2 class="text-center">{{ title }}</h2>

					<v-row no-gutters>
						<v-col cols="12" class="text-right">
							{{ currentdate | formatDateTime }}
						</v-col>
					</v-row>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-if="parameters.length">
					<div class="text-subtitle-1 font-weight-bold">Параметри</div>
					<v-simple-table dense>
						<template v-slot:default>
							<tbody>
								<tr v-for="(item, index) in parameters" :key="index">
									<td width="50%">{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>

				<div class="mx-8 my-6" v-if="data.datasets.ds.length">
					<v-divider></v-divider>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left">ID запиту</th>
									<th class="text-left">Дата запиту</th>
									<th class="text-left">Тип</th>
									<th class="text-left">Номер</th>
									<th class="text-left">VIN-код</th>
									<th class="text-left">Марка</th>
									<th class="text-left">Модель</th>
									<th class="text-left">Користувач</th>
									<th class="text-left">Організація</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in data.datasets.ds" :key="index">
									<td>{{ item.id }}</td>
									<td>{{ item.datecreate }}</td>
									<td>{{ item.TypeName }}</td>
									<td>{{ item.number }}</td>
									<td>{{ item.vin }}</td>
									<td>{{ item.BrandName }}</td>
									<td>{{ item.ModelName }}</td>
									<td>{{ item.UserName }}</td>
									<td>{{ item.OrganizationName }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

export default {
	mixins: [mixin],
	components: { VueHtml2pdf },
	computed: {
		parameters() {
			return [
				{ code: 'datebegin', name: 'Дата початку періоду', description: '', type: 'date', value: this.params.datebegin },
				{ code: 'dateend', name: 'Дата завершення періоду', description: '', type: 'date', value: this.params.dateend },
				{ code: 'organization', name: 'Організація', description: '', type: 'string', value: this.params?.organization?.name },
				{ code: 'option', name: 'Опція', description: '', type: 'string', value: this.params?.option?.name },
			]
		},
	},
}

</script>